export const MAX_GRID_ROW_HEIGHT = 400;

export const isLogTabRe = /\/query-new\/logs(\?.*)?/g;
export const isArchiveQueryPostFixRe = /\/query-new\/archive-logs(\?.*)?/g;
export const isLogsScreenRe = /\/query-new\/(logs|loggregation|archive-logs)/g;

export const selectedSurroundLogInitialData = { id: null, timestamp: null };

export const RELATIVE_GRAPH_DEFAULT = 'No Comparison';
